import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {AiTemplateAcceptTargetType} from 'nutshell-graphql-types';
import type {
    AcceptAiEmailTemplate as AcceptAiEmailTemplateMutation,
    AcceptAiEmailTemplateVariables,
} from 'nutshell-graphql-types';

import type {AiDesignTargetType} from '../../types';

import ACCEPT_AI_EMAIL_TEMPLATE from '../mutations/accept-ai-email-template.graphql';

type AcceptAiEmailTemplateInput = {
    selectedEditionId: string;
    targetCampaignId: string;
    targetType: AiDesignTargetType;
};

export const useAcceptAiEmailTemplate = (): {
    acceptAiEmailTemplate: (arg1: AcceptAiEmailTemplateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [acceptAiEmailTemplateMutation, {loading, error}] = useMutation<
        AcceptAiEmailTemplateMutation,
        AcceptAiEmailTemplateVariables
    >(ACCEPT_AI_EMAIL_TEMPLATE);

    return {
        acceptAiEmailTemplate: (input: AcceptAiEmailTemplateInput) =>
            acceptAiEmailTemplateMutation({
                variables: {
                    input: {
                        selectedEditionId: input.selectedEditionId,
                        targetCampaignId: input.targetCampaignId,
                        targetType: getGraphqlTargetType(input.targetType),
                    },
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};

function getGraphqlTargetType(targetType: AiDesignTargetType): AiTemplateAcceptTargetType {
    switch (targetType) {
        case 'broadcasts':
            return 'BROADCAST';
        case 'templates':
            return 'TEMPLATE';
        case 'newsletters':
            return 'NEWSLETTER';
        case 'drip-sequences':
            return 'DRIP_SEQUENCE';
    }
}
